import React, { useEffect } from 'react';

export default function OrderDrawer({ isOpen, onClose, children }) {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <>
      <div
        className={`pos-order-backdrop ${isOpen ? 'open' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className={`pos-order-drawer ${isOpen ? 'open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Order summary"
      >
        <div className="drawer-handle" />
        <div className="drawer-inner">{children}</div>
      </div>
    </>
  );
}
